import * as Schema from '../schema';
import assembleEntity from '../schema/assembleEntity';
import { createSelector } from 'reselect';

export const selectEnsembles = createSelector(
  [state => state.entities, state => state.maps.ensembles, (state, id) => id],
  (entities, ensembles, id) => {
    if (ensembles[id]) {
      return assembleEntity(Schema.EnsembleList, entities, ensembles[id].entities);
    }
    return [];
  }
);

export const selectEnsemblesIsLoading = (state, id) =>
  state.maps.ensembles[id] && state.maps.ensembles[id].loading;

export const selectNextEnsemblesCursor = (state, id) => {
  const cursor = state.maps.ensembles[id] && state.maps.ensembles[id].meta.cursor;
  if (cursor) {
    return cursor.next;
  }
  return null;
};

export const selectPrevEnsemblesCursor = (state, id) => {
  const cursor = state.maps.ensembles[id] && state.maps.ensembles[id].meta.cursor;
  if (cursor) {
    return cursor.prev;
  }
  return null;
};
